import { createAction } from '@reduxjs/toolkit';

import type { LoadStatePayload } from './loadState';

export const stateLoaded = createAction<LoadStatePayload>('stateLoaded');
